/**
 * Client-side site settings store. Populated by hydratePrototypeRuntime
 * from /api/site-settings. Reads are sync (paint-time) because the
 * call sites (authModalsMarkup "3 free articles a month",
 * aiCreateModalMarkup "1 AI credit", feedbackMarkup live adoption rate)
 * are HTML text injected during initial paint.
 */

export interface SiteSettings {
  authFreeArticlesPerMonth: string;
  aiCreateCreditLabel: string;
  aiCreateQuarterlySaveLabel: string;
  aiCreateAnnualSaveLabel: string;
  socialProofPrivateTopics: string;
  socialProofCompletionRate: string;
  feedbackAdoptionRatePercent: number;
  feedbackSlaHours: number;
  maxConcurrentAiCreateTasks: number;
  communitySubmissionsEnabled: boolean;
  communityCommentsEnabled: boolean;
}

const DEFAULTS: SiteSettings = {
  authFreeArticlesPerMonth: "3 free articles a month",
  aiCreateCreditLabel: "1 AI credit",
  aiCreateQuarterlySaveLabel: "Save 10%",
  aiCreateAnnualSaveLabel: "Save 20%",
  socialProofPrivateTopics: "0",
  socialProofCompletionRate: "No results yet",
	feedbackAdoptionRatePercent: 0,
  feedbackSlaHours: 48,
  maxConcurrentAiCreateTasks: 20,
  communitySubmissionsEnabled: false,
  communityCommentsEnabled: false,
};

let _settings: SiteSettings = DEFAULTS;

export const siteSettingsStore = {
  set(settings: Partial<SiteSettings> | null | undefined): void {
    if (!settings) {
      _settings = DEFAULTS;
      return;
    }
    _settings = { ...DEFAULTS, ...settings };
  },

  get(): SiteSettings {
    return _settings;
  },
};
